import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import React from 'react';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const atlas = new AtlasMetadataClient();

const Headline = (props) => {
  const { vaccinationSummaryStatistics } = props;

  const countriesVaccinating = vaccinationSummaryStatistics.filter(d => d.totalDoses > 0).length;

  // const countriesWithPeople = vaccinationSummaryStatistics.filter(d => d.peopleVaccinated > 0);

  // const totalPeople = countriesWithPeople.reduce((a, d) => a + d.population, 0);
  // const totalPeopleVaccinated = countriesWithPeople.reduce((a, d) => a + d.peopleVaccinated, 0);
  // const totalPercentVaccinated = Math.floor(totalPeopleVaccinated / totalPeople * 100);

  return (
    <section className={classnames(component)}>
      <h3>At least <strong>{countriesVaccinating.toLocaleString('en')} countries</strong> have started vaccinating against <span className=''>COVID-19</span> </h3>
    </section>
  );
};

export default Headline;
